import type { EmailOtpType } from '@supabase/supabase-js';
import { supabase } from '../services/supabase';

const stripRecoveryParams = () => {
  const url = new URL(window.location.href);
  url.searchParams.delete('token_hash');
  url.searchParams.delete('type');
  url.searchParams.delete('code');
  const next = `${url.pathname}${url.search}${url.hash}`;
  window.history.replaceState({}, document.title, next);
};

export const establishPasswordRecoverySession = async (): Promise<{ error: string | null }> => {
  const url = new URL(window.location.href);
  const hash = new URLSearchParams(window.location.hash.replace(/^#/, ''));
  const tokenHash = url.searchParams.get('token_hash') || hash.get('token_hash');
  const type = (url.searchParams.get('type') || hash.get('type') || 'recovery') as EmailOtpType;
  const code = url.searchParams.get('code');

  if (tokenHash) {
    const { error } = await supabase.auth.verifyOtp({
      token_hash: tokenHash,
      type,
    });
    if (!error) stripRecoveryParams();
    return { error: error?.message ?? null };
  }

  if (code) {
    const { error } = await supabase.auth.exchangeCodeForSession(window.location.href);
    if (!error) stripRecoveryParams();
    return { error: error?.message ?? null };
  }

  return { error: null };
};
